// extracted by mini-css-extract-plugin
export default {"p_tye":"_398faf1062","slcted":"_0e4edd26a4","slc_color":"c3b9796416","item_p":"bcdaeaa785","r0":"f0531667e9"};